module.exports = __webpack_public_path__ + "img/plane-suggestion-light.161bfb4.svg";